(() => {
    const config = { attributes: true, childList: true, subtree: true };
    const callback = () => {
        const accessDeniedmessages = document.querySelectorAll('.bss-lock-price-access-deniend-7116');
        accessDeniedmessages.forEach(accessDeniedmessage => {
            if (accessDeniedmessage.href !== 'https://reolinkstore.sg/pages/email-us') {
                accessDeniedmessage.href = 'https://reolinkstore.sg/pages/email-us';
                accessDeniedmessage.style.color = 'red';
                accessDeniedmessage.style.position = 'relative';
                accessDeniedmessage.style.zIndex = '1';
            }
        });
    };
    
    const observer = new MutationObserver(callback);
    
    observer.observe(document.body, config);
})();
